/**
 * The Teamwork Graph edges "Related content" is read over, from the page to the entity the graph
 * infers as related. The first-party edge targets Confluence content; the second targets
 * third-party entities such as Google Drive files and Figma designs.
 */
const RELATED_CONTENT_RELATIONSHIPS = [
	'confluence_content_has_related_confluence_content',
	'confluence_content_has_related_entity',
] as const;

export const MAX_RELATED_CONTENT_PER_RELATIONSHIP = 6;

/** Upper bound on the rows the cypher can return: every edge's branch at its cap. */
export const MAX_RELATED_CONTENT: number =
	MAX_RELATED_CONTENT_PER_RELATIONSHIP * RELATED_CONTENT_RELATIONSHIPS.length;

// One branch per edge, each with its own cap. A single MATCH over both edges under one LIMIT
// would let a page's first-party neighbours crowd every third-party one out.
export const buildRelatedContentCypher = (
	pageAri: string,
	limitPerRelationship: number = MAX_RELATED_CONTENT_PER_RELATIONSHIP,
): string =>
	RELATED_CONTENT_RELATIONSHIPS.map((relationship) =>
		[
			`MATCH (page {ari: "${pageAri}"})-[:${relationship}]->(entity)`,
			'RETURN DISTINCT entity AS relatedContent',
			`LIMIT ${limitPerRelationship}`,
		].join('\n'),
	).join('\nUNION ALL\n');
